// extracted by mini-css-extract-plugin
export default {"pdfPreviewError":"pdfPreviewError_pdfPreviewError__ztzoM"};